import { render, staticRenderFns } from "./LoggedOutDueToInactivityDialog.vue?vue&type=template&id=2d35cce2&scoped=true"
import script from "./LoggedOutDueToInactivityDialog.vue?vue&type=script&lang=js"
export * from "./LoggedOutDueToInactivityDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d35cce2",
  null
  
)

export default component.exports